import { Observable } from 'rxjs';
import { ofType, StateObservable } from 'redux-observable';

import * as actionCreators from '../action-creators';
import { withLatestFrom, concatMap } from 'rxjs/operators';
import { Actions } from '../../actions';
import AppState from '../../state';
import { CreateArtistSuccess } from '../action-creators';
import { CREATE_ARTIST_SUCCESS } from '../actions';
import { push } from 'connected-react-router';
import { OpenMenu } from '../../ui/action-creators';

export const artistCreatedEpic = (
  action$: Observable<Actions>,
  state$: StateObservable<AppState>
) =>
  action$.pipe(
    ofType<Actions, CreateArtistSuccess>(CREATE_ARTIST_SUCCESS),
    withLatestFrom(state$),
    concatMap(([action, state]) => {
      return [
        new actionCreators.GetArtistsSuccess(
          state.artist.myArtists.concat([action.artist])
        ),
        new actionCreators.SetActiveArtist(action.artist, true),
        push('/dashboard'),
        new OpenMenu('VERIFICATION_MENU'),
      ];
    })
  );
